import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "related-transactions-modal" }
const _hoisted_2 = { class: "related-transactions-modal__header-select" }
const _hoisted_3 = { class: "related-transactions-modal__table-wrapper" }
const _hoisted_4 = { class: "related-transactions-modal__table-fixed" }
const _hoisted_5 = { class: "related-transactions-modal__table-scrollable" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }

import { computed, inject } from 'vue';
import { i18n } from '@/i18n';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import SimpleSelectInput from '@/corePagesModule/components/SimpleSelectInput/SimpleSelectInput.vue';
import EzTable from '@/corePagesModule/components/ezTable/EzTable.vue';
import EzTableRow from '@/corePagesModule/components/ezTable/EzTableRow.vue';
import EzHeader from '@/corePagesModule/components/ezTable/EzHeader.vue';
import EzCell from '@/corePagesModule/components/ezTable/EzCell.vue';
import { LoadingStatus } from '@/corePagesModule/components/ezTable/types';
import { key } from '../pages/useRecommendOrderStore';
import { IRelatedTransaction } from '../domains/entities/relatedTransaction';


export default /*@__PURE__*/_defineComponent({
  __name: 'RelatedTransactionsModal',
  props: {
    businessId: {}
  },
  setup(__props: any) {

const props = __props;

const t = i18n.t;
const recommendOrderStore = inject(key);
if (!recommendOrderStore) {
  throw new Error('store is undefined');
}

/**
 * 関連取引モーダルの受領月オフセットの選択肢
 */
const relatedTransactionsReceiptMonthOffsetOptions = computed(() => [t('1ヶ月前内示'), t('2ヶ月前内示'), t('3ヶ月前内示')]);

/**
 * 関連取引モーダルの受領月オフセットの表示値
 */
const relatedTransactionsReceiptMonthOffsetDisplayValue = computed(() => {
  return recommendOrderStore.state.relatedTransactionsReceiptMonthOffset + t('ヶ月前内示');
});

/**
 * 固定カラムのグリッドテンプレート列
 */
const fixedColumnsGridTemplate = computed(() => {
  return ['150px', '150px', '150px', '150px', '100px']; // 売上先コード, 売上先名, 送り先コード, 送り先名, 種類
});

/**
 * スクロール可能な月別カラムのグリッドテンプレート列
 */
const scrollableColumnsGridTemplate = computed(() => {
  if (!recommendOrderStore.state.relatedTransactionsData?.monthlyColumns) {
    return [];
  }
  return recommendOrderStore.state.relatedTransactionsData.monthlyColumns.map(() => '120px');
});

/**
 * テーブルのローディング状態
 */
const relatedTransactionsTableLoadingStatus = computed<LoadingStatus>(() => {
  if (recommendOrderStore.state.relatedTransactionsLoading) {
    return { type: 'loading' };
  }
  if (recommendOrderStore.state.relatedTransactionsError) {
    return { type: 'error', errorMessage: recommendOrderStore.state.relatedTransactionsError };
  }
  if (!recommendOrderStore.state.relatedTransactionsData || recommendOrderStore.state.relatedTransactionsData.transactions.length === 0) {
    return { type: 'zero-match' };
  }
  return { type: 'success' };
});

/**
 * 関連取引モーダルの受領月オフセットを更新する
 * @param value - 選択された値（例: "1ヶ月前内示" または "1 month ago forecast"）
 */
const updateRelatedTransactionsReceiptMonthOffset = async (value: string) => {
  await recommendOrderStore.updateRelatedTransactionsReceiptMonthOffset(props.businessId, value);
};

/**
 * 関連取引モーダルを閉じる
 */
const closeRelatedTransactionsModal = () => {
  recommendOrderStore.closeRelatedTransactionsModal();
};

/**
 * 販売実績の値を取得する
 * @param transaction - 関連取引データ
 * @param year - 年
 * @param month - 月
 */
const getSalesResultValue = (transaction: IRelatedTransaction, year: number, month: number): number | null => {
  const result = transaction.salesResults?.find((sr) => sr.targetYear === year && sr.targetMonth === month);
  return result?.amount ?? null;
};

/**
 * 内示の値を取得する
 * @param transaction - 関連取引データ
 * @param year - 年
 * @param month - 月
 */
const getForecastValue = (transaction: IRelatedTransaction, year: number, month: number): number | null => {
  const result = transaction.customerForecasts?.find((cf) => cf.targetYear === year && cf.targetMonth === month);
  return result?.amount ?? null;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InfoModal, {
    "modal-state": _unref(recommendOrderStore).state.relatedTransactionsModalState,
    "modal-width": 1600,
    "next-button-label": _unref(t)('閉じる'),
    "enable-outside-click": true,
    "no-description": true,
    onOnNext: closeRelatedTransactionsModal,
    onOnBack: closeRelatedTransactionsModal
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('販売実績と内示の明細')), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(SimpleSelectInput, {
            index: 100,
            "select-box-name": "RELATED_TRANSACTIONS_RECEIPT_MONTH_OFFSET",
            "model-value": relatedTransactionsReceiptMonthOffsetDisplayValue.value,
            "prop-options": relatedTransactionsReceiptMonthOffsetOptions.value,
            "display-allow": "",
            "onUpdate:modelValue": updateRelatedTransactionsReceiptMonthOffset
          }, null, 8, ["model-value", "prop-options"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(EzTable, {
              "grid-template-columns": fixedColumnsGridTemplate.value,
              "loading-status": relatedTransactionsTableLoadingStatus.value,
              "sticky-header": "",
              "max-height": "80vh",
              class: "related-transactions-modal__table"
            }, {
              header: _withCtx(() => [
                _createVNode(EzHeader, { class: "related-transactions-modal__header-cell" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('売上先コード')), 1)
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(EzHeader, { class: "related-transactions-modal__header-cell" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('売上先名')), 1)
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(EzHeader, { class: "related-transactions-modal__header-cell" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('送り先コード')), 1)
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(EzHeader, { class: "related-transactions-modal__header-cell" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('送り先名')), 1)
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(EzHeader, { class: "related-transactions-modal__header-cell" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('種類')), 1)
                  ], undefined, true),
                  _: 1
                })
              ]),
              body: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(recommendOrderStore).state.relatedTransactionsData?.transactions || [], (transaction) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: transaction.baseBusinessId
                  }, [
                    _createVNode(EzTableRow, {
                      "grid-template-columns": fixedColumnsGridTemplate.value,
                      class: "related-transactions-modal__row--sales"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(EzCell, {
                          class: "related-transactions-modal__cell",
                          "content-padding": 16
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(transaction.customerNumber), 1)
                          ], undefined, true),
                          _: 2
                        }, 1024),
                        _createVNode(EzCell, {
                          class: "related-transactions-modal__cell",
                          "content-padding": 16
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(transaction.customerName), 1)
                          ], undefined, true),
                          _: 2
                        }, 1024),
                        _createVNode(EzCell, {
                          class: "related-transactions-modal__cell",
                          "content-padding": 16
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(transaction.salesDestinationNumber), 1)
                          ], undefined, true),
                          _: 2
                        }, 1024),
                        _createVNode(EzCell, {
                          class: "related-transactions-modal__cell",
                          "content-padding": 16
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(transaction.salesDestinationName), 1)
                          ], undefined, true),
                          _: 2
                        }, 1024),
                        _createVNode(EzCell, {
                          class: "related-transactions-modal__cell",
                          "content-padding": 16
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('販売実績')), 1)
                          ], undefined, true),
                          _: 1
                        })
                      ], undefined, true),
                      _: 2
                    }, 1032, ["grid-template-columns"]),
                    _createVNode(EzTableRow, {
                      "grid-template-columns": fixedColumnsGridTemplate.value,
                      class: "related-transactions-modal__row--forecast"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(EzCell, {
                          class: "related-transactions-modal__cell",
                          "content-padding": 16
                        }, {
                          default: _withCtx(() => _cache[0] || (_cache[0] = [
                            _createTextVNode(" ")
                          ]), undefined, true),
                          _: 1,
                          __: [0]
                        }),
                        _createVNode(EzCell, {
                          class: "related-transactions-modal__cell",
                          "content-padding": 16
                        }, {
                          default: _withCtx(() => _cache[1] || (_cache[1] = [
                            _createTextVNode(" ")
                          ]), undefined, true),
                          _: 1,
                          __: [1]
                        }),
                        _createVNode(EzCell, {
                          class: "related-transactions-modal__cell",
                          "content-padding": 16
                        }, {
                          default: _withCtx(() => _cache[2] || (_cache[2] = [
                            _createTextVNode(" ")
                          ]), undefined, true),
                          _: 1,
                          __: [2]
                        }),
                        _createVNode(EzCell, {
                          class: "related-transactions-modal__cell",
                          "content-padding": 16
                        }, {
                          default: _withCtx(() => _cache[3] || (_cache[3] = [
                            _createTextVNode(" ")
                          ]), undefined, true),
                          _: 1,
                          __: [3]
                        }),
                        _createVNode(EzCell, {
                          class: "related-transactions-modal__cell",
                          "content-padding": 16
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('内示')), 1)
                          ], undefined, true),
                          _: 1
                        })
                      ], undefined, true),
                      _: 1
                    }, 8, ["grid-template-columns"])
                  ], 64))
                }), 128))
              ]),
              _: 1
            }, 8, ["grid-template-columns", "loading-status"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(EzTable, {
              "grid-template-columns": scrollableColumnsGridTemplate.value,
              "loading-status": relatedTransactionsTableLoadingStatus.value,
              "sticky-header": "",
              "max-height": "80vh",
              class: "related-transactions-modal__table"
            }, {
              header: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(recommendOrderStore).state.relatedTransactionsData?.monthlyColumns || [], (col, index) => {
                  return (_openBlock(), _createBlock(EzHeader, {
                    key: `month-${index}`,
                    class: "related-transactions-modal__header-cell"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(col.year) + "/" + _toDisplayString(String(col.month).padStart(2, '0')), 1)
                    ], undefined, true),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              body: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(recommendOrderStore).state.relatedTransactionsData?.transactions || [], (transaction, transIndex) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: transaction.baseBusinessId
                  }, [
                    _createVNode(EzTableRow, {
                      "grid-template-columns": scrollableColumnsGridTemplate.value,
                      class: "related-transactions-modal__row--sales"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(recommendOrderStore).state.relatedTransactionsData?.monthlyColumns || [], (col, colIndex) => {
                          return (_openBlock(), _createBlock(EzCell, {
                            key: `sales-${transIndex}-${colIndex}`,
                            class: "related-transactions-modal__cell",
                            "content-padding": 16,
                            "force-right": "",
                            "is-number": ""
                          }, {
                            default: _withCtx(() => [
                              (getSalesResultValue(transaction, col.year, col.month) !== null)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(getSalesResultValue(transaction, col.year, col.month)?.toLocaleString()), 1))
                                : _createCommentVNode("", true)
                            ], undefined, true),
                            _: 2
                          }, 1024))
                        }), 128))
                      ], undefined, true),
                      _: 2
                    }, 1032, ["grid-template-columns"]),
                    _createVNode(EzTableRow, {
                      "grid-template-columns": scrollableColumnsGridTemplate.value,
                      class: "related-transactions-modal__row--forecast"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(recommendOrderStore).state.relatedTransactionsData?.monthlyColumns || [], (col, colIndex) => {
                          return (_openBlock(), _createBlock(EzCell, {
                            key: `forecast-${transIndex}-${colIndex}`,
                            class: "related-transactions-modal__cell",
                            "content-padding": 16,
                            "force-right": "",
                            "is-number": ""
                          }, {
                            default: _withCtx(() => [
                              (getForecastValue(transaction, col.year, col.month) !== null)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(getForecastValue(transaction, col.year, col.month)?.toLocaleString()), 1))
                                : _createCommentVNode("", true)
                            ], undefined, true),
                            _: 2
                          }, 1024))
                        }), 128))
                      ], undefined, true),
                      _: 2
                    }, 1032, ["grid-template-columns"])
                  ], 64))
                }), 128))
              ]),
              _: 1
            }, 8, ["grid-template-columns", "loading-status"])
          ])
        ])
      ])
    ], undefined, true),
    _: 1
  }, 8, ["modal-state", "next-button-label"]))
}
}

})